export default {
  title: 'Sieht aus, als ob du offline bist',
  description:
    'Bitte klicke auf “Seite neu laden” und/oder überprüfe deine Internetverbindung, um sicherzustellen, dass du online bist 😊',
  custom_button: {
    reload: 'Seite neu laden',
  },
};
